/**
 * List of all the networks supported by LSS Protocol
 */
export enum SupportedChainId {
  MAINNET = 1,
  BSC = 56,
  POLYGON = 137,
  FANTOM = 43114,
  RINKEBY = 4,
}

export const CHAIN_IDS_TO_NAMES = {
  [SupportedChainId.MAINNET]: "mainnet",
  [SupportedChainId.RINKEBY]: "rinkeby",
  [SupportedChainId.BSC]: "bsc",
  [SupportedChainId.POLYGON]: "polygon",
  [SupportedChainId.FANTOM]: "fantom",
};

export type ChainInfo = {
  name: string;
  dispersAddress: string;
  addressesPerTransaction: number;
};

export const ChainData: { [chainId: number]: ChainInfo } = {
  [SupportedChainId.MAINNET]: {
    name: "ETH Mainnet",
    dispersAddress: "0xD152f549545093347A162Dce210e7293f1452150",
    addressesPerTransaction: 150,
  },
  [SupportedChainId.BSC]: {
    name: "BSC",
    dispersAddress: "0xD152f549545093347A162Dce210e7293f1452150",
    addressesPerTransaction: 150,
  },
  [SupportedChainId.POLYGON]: {
    name: "Polygon",
    dispersAddress: "0xD152f549545093347A162Dce210e7293f1452150",
    addressesPerTransaction: 150,
  },
  [SupportedChainId.FANTOM]: {
    name: "Fantom",
    dispersAddress: "0xD152f549545093347A162Dce210e7293f1452150",
    addressesPerTransaction: 150,
  },
  [SupportedChainId.RINKEBY]: {
    name: "Rinkeby Testnet",
    dispersAddress: "0xD152f549545093347A162Dce210e7293f1452150",
    addressesPerTransaction: 150,
  },
};

/**
 * Array of all the supported chain IDs
 */
export const ALL_SUPPORTED_CHAIN_IDS: SupportedChainId[] = Object.values(
  SupportedChainId
).filter((id) => typeof id === "number") as SupportedChainId[];

export const isUnsupportedNetwork = (chainId: number | undefined): boolean => {
  return !ALL_SUPPORTED_CHAIN_IDS.includes(chainId as SupportedChainId);
};

// MULTIPLE ADDRESSES FOR THE DISPERSER CONTRACT
// address: {
//   1: "0xD152f549545093347A162Dce210e7293f1452150",
//   3: "0xD152f549545093347A162Dce210e7293f1452150",
//   4: "0xD152f549545093347A162Dce210e7293f1452150",
//   5: "0xD152f549545093347A162Dce210e7293f1452150",
//   42: "0xD152f549545093347A162Dce210e7293f1452150",
//   56: "0xD152f549545093347A162Dce210e7293f1452150",
//   77: "0xD152f549545093347A162Dce210e7293f1452150",
//   99: "0xD152f549545093347A162Dce210e7293f1452150",
//   100: "0xD152f549545093347A162Dce210e7293f1452150",
//   137: "0xD152f549545093347A162Dce210e7293f1452150",
//   163: "0xD152f549545093347A162Dce210e7293f1452150",
//   250: "0xD152f549545093347A162Dce210e7293f1452150",
//   5777: "0x5b1869d9a4c187f2eaa108f3062412ecf0526b24",
//   42161: "0x692B5A7eCcCad243a07535E8C24B0E7433238C6a",
//   4689: "0xe3122e446Bf31036DA212375803f24b3dE96D0c9",
//   1284: "0xD152f549545093347A162Dce210e7293f1452150",
//   1285: "0xD152f549545093347A162Dce210e7293f1452150",
//   42220: "0xD152f549545093347A162Dce210e7293f1452150",
//   1666600000: "0xD152f549545093347A162Dce210e7293f1452150",
//   60: "0xD152f549545093347A162Dce210e7293f1452150",
//   128: "0xD152f549545093347A162Dce210e7293f1452150",
//   66: "0xD152f549545093347A162Dce210e7293f1452150",
//   10: "0xD152f549545093347A162Dce210e7293f1452150"
// }
